<template>
<div class="container column justify-content-center align-items-center">
  <div
    v-for="(x, index) in data"
    class="container--booksList animation-bottom"
    :style="{animationDelay: (index / 5) + 's'}"
    :key="`book-${index}`"
  >
    <div class="booksList--box shadow-small" :class="x.class">
      <div class="booksList--box__block container wrap justify-content-center align-items-center">
        <div class="booksList--box__block-status flex-grow-1 text-center">
          <img :src="require(`@/assets/img/${checkBook(x) ? 'bookunlook.svg' : 'booklook.svg'}`)"  alt="Status" class="">
        </div>
        <div class="booksList--box__block-title flex-grow-2 text-center">
          book.<span>{{x.title}}</span>
        </div>

        <div class="booksList--box__block-description flex-grow-3 flex-basis-200">
          <p>{{x.description}}</p>
        </div>
        <div class="booksList--box__block-btns container align-center flex-basis-100">
          <div v-if="checkBook(x)">
            <a @click="goToBook(x)" class="btn btn-rounded gradient-books" style="width: 130px;">
              {{ isReview ? 'REVIEW' : (inVirtualArea ? 'VIEW' : 'UNITS') }} <i class="margin-left-5 fas fa-arrow-right"></i>
            </a>
          </div>
          <div v-else>
            <span class="btn btn-rounded gradient-books" style="cursor: pointer;width: 130px;" @click="add"> UNBLOCK BOOK </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'bookList',
  props: {
    data: {
      type: Array
    },
    add: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      books: 'book/getAll',
      book: 'book/get',
      isReview: 'isReview',
      inVirtualArea: 'inVirtualArea',
      virtualBooks: 'virtualBook/getBooks',
      student: 'student/GET',
      teensBooks: 'teens/GET_BOOKS'
    })
  },
  methods: {
    checkBook (book) {
      const booksList = this.inVirtualArea ? this.virtualBooks : (!this.student.teens ? this.books : this.teensBooks)

      for (const b of booksList) {
        if (this.inVirtualArea) {
          if (b.number === book.id) {
            this.$set(book, '_id', b.id)
            return true
          }
        } else {
          if (b.title.replace('Book ', '') === book.title) {
            this.$set(book, '_id', b._id)
            return true
          }
        }
      }
      return false
    },
    async goToBook (book) {
      this.$store.commit('setShowLoader', true)

      const uid = book._id

      if (this.isReview) {
        await this.$store.dispatch('book/fetchRevisionBook', uid)
      } else if (this.inVirtualArea) {
        this.$router.push({ name: 'virtualBook', params: { book: uid } })
        this.$store.commit('setShowLoader', false)
        return
      } else if (!!this.student.teens) {
        await this.$store.dispatch('teens/setBook', uid)
        this.$router.push({ name: 'book', params: { book: `Book ${book.title}` } })
        this.$store.commit('setShowLoader', false)
        return
      } else {
        if (!this.student.teens) {
          await this.$store.dispatch('book/fetchBook', uid)
          await this.$store.dispatch('unit/setUnit')
        }
      }
      this.$store.commit('setShowLoader', false)
      this.$router.push({ name: this.isReview ? 'book-review' : 'book', params: { book: this.book.title } })
    }
  }
}
</script>

<style lang="scss" scoped>
.box-content-border .container--booksList:last-child .booksList--box {
    margin-bottom: 0!important;
}

.container--booksList {
    // width: 680px;
    width: 100%;
    max-width: 100%;
}
.booksList--box {
    color: #fff;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
    width: 100%;
    border-radius: 10px;
    margin-bottom: 20px;
    transition: 0.3s;
    &:hover {
        transform: scale(1.015, 1.015);
    }
    .booksList--box__block {
        width: 100%;
        min-height: 132px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 15px;
        padding-bottom: 15px;
        .booksList--box__block-title {
            margin: 15px;
            font-weight: 200;
            font-size: 25px;
            span {
                font-weight: 900;
                text-transform: uppercase;
                font-size: 40px;
            }
            @media (max-width: 440px){
              font-size: 21px;
            }
        }
        .booksList--box__block-status {
            margin: 0px 0px 0px 15px;
            // font-weight: 100;
            // font-size: 35px;
        }
        .booksList--box__block-description {
            // margin: 15px;
            p {
                font-weight: 200;
                line-height: 1.4;
                @media (max-width: 440px){
                  padding: 5px 20px;
                }
            }
        }
        .booksList--box__block-btns {
            margin: 15px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/books/index.vue